(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// =========
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.trans = this.dataset.trans;
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
    this.onScroll();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isProductHeaderPage = document.body.classList.contains('template-product');
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    // Measure once per scroll event. This was read up to three times below,
    // and every read that follows a classList change forces a fresh layout.
    const headerHeight = this.header.offsetHeight;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > headerHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > headerHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top || scrollTop < headerHeight) {
      this.header.classList.remove('scrolled-past-header');
      if(this.trans != 'false' && !isProductHeaderPage) this.classList.add('transparent_header');
      document.body.classList.remove('sticky-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-cloud-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOnCloudHero(section) {
      if (!section || section.dataset.onCloudInit === 'true') return;
      section.dataset.onCloudInit = 'true';

      var visual = section.querySelector('[data-on-cloud-visual]');
      if (!visual) return;

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) return;

      var ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var rect = section.getBoundingClientRect();
          var progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
          var offset = (progress - 0.5) * 28;
          visual.style.setProperty('--parallax-y', offset.toFixed(2) + 'px');
          ticking = false;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    document.querySelectorAll('[data-on-cloud-hero]').forEach(initOnCloudHero);
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-on-cloud-hero]');
      if (el) initOnCloudHero(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tri-sole-motion-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Slides 2+ hold their image URLs in data- attributes so they cannot
    // compete with the one on screen for bandwidth. This puts them back: after
    // load, or sooner if the carousel is about to move or is touched. Running
    // twice is harmless -- the attributes are removed as they are consumed.
    function hydrateSlides(root) {
      if (!root || root.dataset.motionHydrated === 'true') return;
      root.dataset.motionHydrated = 'true';
      var parked = root.querySelectorAll('[data-motion-defer]');
      for (var i = 0; i < parked.length; i++) {
        var el = parked[i];
        if (el.dataset.srcset) el.setAttribute('srcset', el.dataset.srcset);
        if (el.dataset.src) el.setAttribute('src', el.dataset.src);
        el.removeAttribute('data-motion-defer');
      }
    }

    function initTriSoleMotion(root) {
      if (!root || root.dataset.motionReady === 'true') return;
      root.dataset.motionReady = 'true';

      var slides = root.querySelectorAll('[data-motion-slide]');
      if (!slides.length) return;

      var current = 0;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = parseInt(root.dataset.speed, 10) || 6000;
      var dots = root.querySelectorAll('[data-motion-dot]');
      var prevBtn = root.querySelector('[data-motion-prev]');
      var nextBtn = root.querySelector('[data-motion-next]');
      var timer;

      function setActive(index) {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        current = index;
        slides[current].classList.add('is-active');
        slides[current].removeAttribute('aria-hidden');

        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function goTo(index) {
        hydrateSlides(root);
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        if (index === current) return;
        setActive(index);
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      function restart() {
        clearInterval(timer);
        if (autoplay && slides.length > 1) {
          timer = setInterval(next, speed);
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.motionDot, 10));
          restart();
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);

      var wake = function () { hydrateSlides(root); };
      root.addEventListener('pointerdown', wake, { once: true });
      root.addEventListener('touchstart', wake, { once: true, passive: true });
      if (document.readyState === 'complete') {
        wake();
      } else {
        window.addEventListener('load', wake, { once: true });
      }

      restart();
    }

    document.querySelectorAll('[data-tri-sole-motion]').forEach(initTriSoleMotion);
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-tri-sole-motion]');
      if (el) initTriSoleMotion(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
